import * as React from 'react';
import { Select } from '@lightspeed/flame/Select';
import { Flex } from '@lightspeed/flame/Core';

import CommonData from 'app/src/data/CommonData';
import Localize from 'app/src/localize/Localize';
import { usePaymentContext } from '../Store/PaymentState';

export const CreditCardTerminalList = () => {
  const { paymentProvider, selectedTerminalId, setSelectedTerminalId } = usePaymentContext();

  const [creditCardTerminalList, setCreditCardTerminalList] = React.useState([]);

  React.useEffect(() => {
    if (paymentProvider && paymentProvider.terminalCollection) {
      setCreditCardTerminalList(paymentProvider.terminalCollection.toJSON());
    }
  }, [paymentProvider]);

  React.useEffect(() => {
    if (CommonData.selectedRegister) {
      const savedTerminal = CommonData.selectedRegister.get('ccTerminalID');
      if (savedTerminal !== selectedTerminalId) {
        setSelectedTerminalId(CommonData.selectedRegister.get('ccTerminalID'));
      }
    }
  }, [selectedTerminalId, setSelectedTerminalId]);

  const onTerminalSelectChanged = (event: TSFixMe) => {
    const terminalSelect = event.target.value;
    setSelectedTerminalId(terminalSelect);

    // TODO: Add payment analytics with newRelic.
    CommonData.selectedRegister.set('ccTerminalID', terminalSelect).save();
  };
  return (
    <Flex py={1} flexWrap="wrap" className="payment-steps">
      <Select
        id="terminal_select"
        aria-label="terminal selection"
        onChange={onTerminalSelectChanged}
        value={selectedTerminalId}
      >
        <option
          data-term-id="select-terminal"
          value="select-terminal"
          key="select-terminal"
          aria-label="select-terminal"
        >
          {Localize.translate('Select a Terminal')}
        </option>
        {creditCardTerminalList.map(terminal => (
          <option
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'ccTerminalID' does not exist on type 'ne... Remove this comment to see the full error message
            key={`${terminal.ccTerminalID}`}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'ccTerminalID' does not exist on type 'ne... Remove this comment to see the full error message
            value={terminal.ccTerminalID}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'ccTerminalID' does not exist on type 'ne... Remove this comment to see the full error message
            data-term-id={terminal.ccTerminalID}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'never'.
            aria-label={`${terminal.name}-terminal`}
          >
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'never'. */}
            {terminal.name}
          </option>
        ))}
      </Select>
    </Flex>
  );
};
